module.exports = __webpack_public_path__ + "img/venus5.119a2674.png";